import React from 'react';
import get from 'lodash.get';

import ErrorBoundary from 'components/ErrorBoundary';
import { AdController, FrontAdController } from 'lib/AdControllers';
import LayoutContext from './LayoutContext';
import FullWidth from './FullWidth';
import LeftRail from './LeftRail';
import LeftRailWithSplitRow from './LeftRailWithSplitRow';
import RightRail from './RightRail';
import RightRailTabbed from './RightRailTabbed';
import RightRailWithSplitRow from './RightRailWithSplitRow';
import TodayCoverTabbedLayout from './TodayCoverTabbedLayout';

function getLayout(layoutType, props) {
  switch (layoutType) {
    case 'fullWidth':
      return <FullWidth {...props} />;
    case 'leftRail':
      return <LeftRail {...props} />;
    case 'leftRailWithSplitRow':
      return <LeftRailWithSplitRow {...props} />;
    case 'rightRail':
      return <RightRail {...props} />;
    case 'rightRailTabbed':
      return <RightRailTabbed {...props} />;
    case 'rightRailWithSplitRow':
      return <RightRailWithSplitRow {...props} />;
    case 'rightRailTabbedToday':
      return <TodayCoverTabbedLayout {...props} />;
    default:
      return null;
  }
}

export default ({
  adsDisabled,
  curationAutofill,
  layouts,
  pageRoute,
  vertical,
}) => {
  const isCover = pageRoute === '/';
  const isTodayVertical = vertical === 'today';
  const isTodayCoverPage = (isCover && isTodayVertical);
  const isGlobalCitizen = vertical === 'globalcitizen';

  let adController;
  if (isCover && !isGlobalCitizen) {
    const adRulesKey = isTodayCoverPage ? 'today:cover' : vertical;
    adController = new AdController(vertical, layouts, adRulesKey);
  } else {
    adController = new FrontAdController(vertical, layouts);
  }

  const isEligibleForAdInsertion = ['news', 'today', 'msnbc', 'globalcitizen'].includes(vertical);
  let foundFirstRail = false;
  let leadPackageType = null;
  let foundFirstLayoutWithPackages = false;

  const zoneAFilled = get(layouts, '[0].packages.length');

  return (layout, index) => {
    let packages = layout.packages.slice(0);
    let isFirstLayoutWithPackages = false;
    if (layout && packages && !foundFirstLayoutWithPackages) {
      foundFirstLayoutWithPackages = true;
      isFirstLayoutWithPackages = true;
    }
    if (!leadPackageType && index === 0) {
      leadPackageType = (packages && packages[0] && packages[0].type) || null;
    }

    // only show ads on today, news, and msnbc
    if (isEligibleForAdInsertion && !adsDisabled) {
      packages = adController.addCustomAds(layout, packages);
    }


    const isRailLayout = /rail/i.test(layout.type);
    const isFirstRail = isRailLayout && !foundFirstRail;
    if (isFirstRail) foundFirstRail = true;

    const layoutComponent = getLayout(layout.type, { key: layout.id, packages, zoneAFilled });
    return layoutComponent && (
      <ErrorBoundary key={`ErrorBoundary(${layout.id})`}>
        <LayoutContext
          layoutIndex={index}
          layoutType={layout.type}
          vertical={vertical}
          pageRoute={pageRoute}
          isRailLayout={isRailLayout}
          isFirstRail={isFirstRail}
          leadPackageType={leadPackageType}
          curationAutofill={curationAutofill}
          adsDisabled={adsDisabled}
          isFirstLayoutWithPackages={isFirstLayoutWithPackages}
        >
          {layoutComponent}
        </LayoutContext>
      </ErrorBoundary>
    );
  };
};
